import React, { useState } from "react";
import { Box, Card, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import KeyIcon from "@mui/icons-material/Key";
import LocalCafeIcon from "@mui/icons-material/LocalCafe";

const extraServices = [
  {
    key: "car",
    fi: "Sijaisauto",
    en: "Replacement car",
    descFi: "Asiakkaalle tarjotaan sijaisauto huollon ajaksi",
    descEn: "A replacement car is offered to the customer for the duration of the service",
    icon: <DirectionsCarIcon />,
    selected: true,
  },
  {
    key: "key",
    fi: "Avainlaatikko",
    en: "Key box",
    descFi: "Asiakas voi jättää avaimen lukolliseen avainlaatikkoon",
    descEn: "The customer can leave the key in a locked key box",
    icon: <KeyIcon />,
    selected: false,
  },
  {
    key: "coffee",
    fi: "Kahvi & odotus",
    en: "Coffee & waiting area",
    descFi: "Odotustila kahvitarjoilulla huollon ajaksi",
    descEn: "A waiting area with coffee service during the service",
    icon: <LocalCafeIcon />,
    selected: false,
  },
];

const AdditionalServices = () => {
  const { t } = useTranslation();
  const [selectedExtra, setSelectedExtra] = useState("car");

  return (
    <Paper variant='outlined' sx={{ borderColor: "#e3e6ec", borderRadius: 2, p: 3, mb: 4 }}>
      <Box sx={{ mb: 0.5 }}>
        <Typography variant={"subtitle1"} sx={{ fontWeight: 700, color: "#003C59", lineHeight: 1.3 }}>
          {t("workshopAdditionalServices.additionalServices")}
        </Typography>
      </Box>
      <Box sx={{ mb: 2 }}>
        <Typography variant={"body2"} sx={{ fontWeight: 400, color: "text.primary", lineHeight: 1.3 }}>
          {t("workshopAdditionalServices.additionalServicesDescription")}
        </Typography>
      </Box>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
        {extraServices.map((svc) => {
          const isSelected = selectedExtra === svc.key;
          return (
            <Card
              key={svc.key}
              variant='outlined'
              onClick={() => setSelectedExtra(svc.key)}
              sx={{
                flex: 1,
                p: 2,
                cursor: "pointer",
                borderRadius: 2,
                borderColor: isSelected ? "#003C59" : "#e3e6ec",
                bgcolor: isSelected ? "#003C59" : "#fff",
                color: isSelected ? "#fff" : "text.primary",
                transition: "all 0.15s ease",
              }}
            >
              <Box sx={{ mb: 1, color: isSelected ? "#fff" : "#003C59" }}>{svc.icon}</Box>
              <Typography sx={{ fontWeight: 700, mb: 0.25 }}>{svc.fi}</Typography>
              <Typography variant='caption' sx={{ display: "block", color: isSelected ? "rgba(255,255,255,0.7)" : "#8a94a6", mb: 1 }}>
                {svc.en}
              </Typography>
              <Typography variant='body2' sx={{ color: isSelected ? "rgba(255,255,255,0.9)" : "text.secondary" }}>
                {svc.descFi}
              </Typography>
              <Typography variant='caption' sx={{ display: "block", color: isSelected ? "rgba(255,255,255,0.6)" : "#8a94a6", mb: 1 }}>
                {svc.descEn}
              </Typography>
              {isSelected && (
                <Typography variant='caption' sx={{ color: "#00C9DB", fontWeight: 700 }}>
                  ● Valittu{" "}
                  <Box component='span' sx={{ color: "rgba(255,255,255,0.6)", fontWeight: 400 }}>
                    / Selected
                  </Box>
                </Typography>
              )}
            </Card>
          );
        })}
      </Stack>
    </Paper>
  );
};

export default AdditionalServices;
